/**
 * Adds a state loading behaviour to enable all categories previously enabled before
 * a page reload due to user login.
 */
export class LoadStateGroupNav {
  constructor(parent) {
    this.parent = parent;
  }

  onStateLoaded() {
    // enable this category
    this.parent.$container.addClass('has-selection');
    this.parent.$container.addClass("enabled");

    const $next = this.parent.$container.nextAll().first(':visible');
    const $prev = this.parent.$container.prevAll().first(':visible');

    const top = this.parent.$container.find('.title').position().top - this.parent.controller.$iemSelectContainer.height();
    const scrollTop = top + this.parent.controller.$formContainer.scrollTop() - this.parent.controller.$formContainer.offset().top;
    this.parent.controller.$formContainer.scrollTop(scrollTop);

    // collapse last category to make this one the open one
    if ($prev && $prev.length > 0) {
      $prev.addClass('collapsed');
    }

    // enable next category so its available for selection.
    if ($next && $next.length > 0) {
      $next.addClass('enabled');
    }
  }
}